import { render } from "./download.vue?vue&type=template&id=338f4460&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=338f4460&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/official-accounts/official-accounts/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338f4460"]])

export default __exports__